// Peças comuns das despesas e do "A pagar": formas de pagamento, nome da
// despesa e o diálogo "Paguei".
import { h } from '../lib/dom.js';
import { data, dinheiro, placa as formatarPlaca } from '../lib/formato.js';
import { hojeDaEmpresa } from '../sessao.js';
import { dialogo } from '../ui/componentes.js';

export const FORMAS_PAGAMENTO = [
  ['pix', 'Pix'],
  ['dinheiro', 'Dinheiro'],
  ['cartao', 'Cartão'],
  ['boleto', 'Boleto'],
  ['tag', 'Tag'],
  ['transferencia', 'Transferência'],
  ['faturado', 'Faturado (paga depois)'],
  ['outro', 'Outro'],
];
export const NOME_FORMA = Object.fromEntries(FORMAS_PAGAMENTO);

// "Diesel · MDT7J86" / "Seguro do Scania (parcela 3/12)"
export function nomeDaDespesa(despesa, { categoria = null, veiculo = null } = {}) {
  const partes = [despesa.descricao && despesa.recorrencia_id ? despesa.descricao : categoria?.nome ?? 'Despesa'];
  if (veiculo) partes.push(formatarPlaca(veiculo.placa));
  return partes.join(' · ');
}

// Diálogo "Paguei": a data do pagamento (e a forma, para as parcelas).
// Devolve { pago_em, forma } ou null.
export function dialogoPagar({ titulo, detalhe = null, valor, vencimento = null, formaPadrao = null, comForma = true }) {
  const hoje = hojeDaEmpresa();
  return dialogo((fechar) => {
    const quando = h('input', { type: 'date', id: 'pagar-quando', value: hoje, max: hoje });
    const forma = h('select', { id: 'pagar-forma' },
      h('option', { value: '' }, 'Não informar'),
      FORMAS_PAGAMENTO.filter(([v]) => v !== 'faturado').map(([v, t]) => h('option', { value: v, selected: v === formaPadrao }, t)));
    const erro = h('p', { class: 'erro-campo', role: 'alert' });
    return [
      h('h2', null, titulo),
      h('p', null, `${dinheiro(valor)}${vencimento ? ` · vencimento ${data(vencimento)}` : ''}`),
      detalhe && h('p', { class: 'pequeno' }, detalhe),
      h('div', { class: 'campo' }, h('label', { for: 'pagar-quando' }, 'Pago em'), quando),
      comForma && h('div', { class: 'campo' }, h('label', { for: 'pagar-forma' }, 'Como foi pago'), forma),
      erro,
      h('div', { class: 'acoes' },
        h('button', {
          class: 'botao cheio',
          type: 'button',
          onClick: () => {
            if (!quando.value) {
              erro.textContent = 'Informe a data do pagamento.';
              return;
            }
            if (quando.value > hoje) {
              erro.textContent = 'A data do pagamento não pode ser no futuro.';
              return;
            }
            fechar({ pago_em: quando.value, forma: comForma ? forma.value || null : null });
          },
        }, 'Confirmar pagamento'),
        h('button', { class: 'botao cheio secundario', type: 'button', onClick: () => fechar(null) }, 'Cancelar')),
    ];
  });
}
